var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 13 13" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M6.5 13a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM4.98 4.763c.396-.8.914-1.152 1.637-1.152.857 0 1.327.623 1.327 1.444.006.655-.578 1.385-1.873 2.159a.722.722 0 1 0 .741 1.24C8.502 7.444 9.4 6.32 9.39 5.049c0-1.539-1.015-2.882-2.772-2.882-1.297 0-2.301.683-2.931 1.955a.722.722 0 1 0 1.295.641zm1.52 6.07a.722.722 0 1 0 0-1.444.722.722 0 0 0 0 1.444z" })
  );
});